export const ORDER_TYPE = Object.freeze({
  ASC: 'asc',
  DESC: 'desc'
})
